<div
  class="metric-card"
  [style.--card-border-color]="card().iconBackgroundColor ?? 'var(--text-secondary, #6c757d)'"
>
  @if (card().isLoading) {
    <div class="metric-content">
      <div class="skeleton-line skeleton-value"></div>
      <div class="skeleton-line skeleton-title"></div>
      <div class="skeleton-line skeleton-subtext"></div>
    </div>
    <div class="skeleton-line skeleton-icon"></div>
  } @else {
    <div class="metric-content">
      <div class="metric-value">{{ card().value }}</div>
      <div class="metric-title">{{ card().title | translate }}</div>

      @if (card().subtext) {
        <div class="metric-subtext">{{ card().subtext }}</div>
      }

      @if (card().path) {
        <a class="see-more" [routerLink]="card().path">{{ 'COMMON.SEE_MORE' | translate }}</a>
      }
    </div>

    <div
      class="metric-icon-container"
      [style.background-color]="card().iconBackgroundColor ?? 'var(--text-secondary, #6c757d)'"
    >
      <mat-icon [style.color]="card().iconColor ?? '#ffffff'">{{ card().icon }}</mat-icon>
    </div>
  }
</div>
